/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled      from 'styled-components';
import PropTypes   from 'prop-types';
import { Spacing } from '../../../styles/variables';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledLabel = styled.label`
  display: ${props => props.hide === true ? 'none' : 'block' };
  margin-bottom: ${Spacing.Tiny};
  font-weight: 700;
`;

StyledLabel.propTypes = {
    hide: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/atoms/StyledLabel/index.js